import { Flex } from '@mantine/core';
import { KycActionButton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/KycActionButton';
import {
	AcceptanceStatus,
	DataKYCFileTctWithFile,
	GetKYCInvestorInstanceRes,
} from '@dealstack/shared/lib/generated';
import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { TEST_ELEMENT_IDS } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';

interface Props {
	currentInvestor: GetKYCInvestorInstanceRes | undefined;
	currentStep: Step;
	selectedKycFile: DataKYCFileTctWithFile | undefined;
	loading: boolean;
	isDisabled?: boolean;
	/** Approval alone can be blocked, e.g. while a certifier has not signed yet. */
	isApproveDisabled?: boolean;
	onApprove: () => Promise<void>;
	onDecline: () => Promise<void>;
	approvalStatusOverride?: AcceptanceStatus;
}

export const KycActionButtons = ({
	currentInvestor,
	currentStep,
	selectedKycFile,
	loading,
	isDisabled,
	isApproveDisabled = false,
	onApprove,
	onDecline,
	approvalStatusOverride,
}: Props) => {
	return (
		<Flex gap="0.5rem" w="100%">
			<KycActionButton
				currentInvestor={currentInvestor}
				currentStep={currentStep}
				selectedKycFile={selectedKycFile}
				variant="approve"
				isLoading={loading}
				isDisabled={isDisabled || isApproveDisabled}
				onClick={onApprove}
				approvalStatusOverride={approvalStatusOverride}
				dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_KYC_REVIEW_ACCEPT_BUTTON}
			/>

			<KycActionButton
				currentInvestor={currentInvestor}
				currentStep={currentStep}
				selectedKycFile={selectedKycFile}
				variant="decline"
				isLoading={loading}
				isDisabled={isDisabled}
				onClick={onDecline}
				approvalStatusOverride={approvalStatusOverride}
				dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_KYC_REVIEW_REJECT_BUTTON}
			/>
		</Flex>
	);
};
